import Ajax from '../ajax';

export default {
  list: (merchantId, filter) => Ajax('get', `merchant/${merchantId}/announcement`, filter),
  add: (merchantId, data) => Ajax('post', `merchant/${merchantId}/announcement`, data),
  edit: (merchantId, announcementId, data) => Ajax('put', `merchant/${merchantId}/announcement/${announcementId}`, data),
  delete: (merchantId, announcementId) => Ajax('delete', `merchant/${merchantId}/announcement/${announcementId}`),
};
